import { render, staticRenderFns } from "./Wizyta.vue?vue&type=template&id=57affdd6&scoped=true&"
import script from "./Wizyta.vue?vue&type=script&lang=js&"
export * from "./Wizyta.vue?vue&type=script&lang=js&"
import style0 from "./Wizyta.vue?vue&type=style&index=0&id=57affdd6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57affdd6",
  null
  
)

export default component.exports